import React from 'react';
import { useHistory } from "react-router-dom";
import { LayoutMode, LayoutProps } from './types';
import InitialContext from 'state/static-data/InitialContext';
import { BUY_BOX_PAGE_TYPE } from 'state/types';

import StatesWidget from './states';
import TwisterWidget from './variations';

export type LayoutAwareAppProps = LayoutProps;
const LayoutAwareApp = (props: LayoutAwareAppProps) => {
    const history = useHistory();
    const { layoutMode } = props;
    const clinicLogoWhiteImageLink = "https://m.media-amazon.com/images/G/01/katara/logos/clinic-logo-white.svg";
    const onBackClick = () => {
        history.goBack();
    };
    const innerContent = (<pui-section class={InitialContext.getPageType() === BUY_BOX_PAGE_TYPE.DETAIL_PAGE ? "clinic-dp-box" : "clinic-offer-buybox content-container"}>
        <StatesWidget {...props} />
        <TwisterWidget {...props} />
    </pui-section>);
    if (layoutMode === LayoutMode.DESKTOP) {
        return (
            <>
                {InitialContext.getPageType() === BUY_BOX_PAGE_TYPE.OFFER_BUYBOX_PAGE &&
                    !InitialContext.getIsMShopApp() &&
                    <div className='offer-page-banner'>
                        <span className="offer-page-banner-content offer-page-banner-back-button" onClick={onBackClick}>
                            <pui-icon imgClass="back-arrow-icon"></pui-icon>
                        </span>
                        <div className="offer-page-banner-content offer-page-banner-logo">
                            <a href="/?ref_=offer_banner_logo">
                                <img role="img" src={clinicLogoWhiteImageLink} alt="Amazon Clinic"/>
                            </a>
                        </div>
                        <span className="offer-page-banner-content offer-page-banner-help-button">
                            <a href="/help?ref_=offer_nav_help">Help</a>
                        </span>
                    </div>}
                <pui-card noShadow class={InitialContext.getPageType() === BUY_BOX_PAGE_TYPE.DETAIL_PAGE ? "cdp-desktop-box" : "offer-page"}>
                    {innerContent}
                </pui-card>
            </>
        )
    }
    return innerContent;
}
export default LayoutAwareApp;